import Pagination from 'components/Pagination/Pagination'
import './Home.css'
import { useNavigate, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { trackCtaClick } from 'services/analyticsService'

const Home = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()

  const partners = [
    { id: 1, src: '/assets/Home/ClientsAndPartners/Partners/databricks.png', alt: '' },
    { id: 2, src: '/assets/Home/ClientsAndPartners/Partners/aws.png', alt: '' },
    { id: 3, src: '/assets/Home/ClientsAndPartners/Partners/dassault.png', alt: '' },
    { id: 4, src: '/assets/Home/ClientsAndPartners/Partners/sap.png', alt: '' },
    { id: 5, src: '/assets/Home/ClientsAndPartners/Partners/omp.png', alt: '' },
  ]

  const clients = [
    { id: 3, src: '/assets/Home/ClientsAndPartners/Clients/imagem5.png', alt: '' },
    { id: 4, src: '/assets/Home/ClientsAndPartners/Clients/imagem6.png', alt: '' },
    { id: 5, src: '/assets/Home/ClientsAndPartners/Clients/imagem7.jpg', alt: '' },
    { id: 6, src: '/assets/Home/ClientsAndPartners/Clients/imagem8.png', alt: '' },
    { id: 7, src: '/assets/Home/ClientsAndPartners/Clients/imagem9.png', alt: '' },
    { id: 8, src: '/assets/Home/ClientsAndPartners/Clients/imagem10.png', alt: '' },
    { id: 9, src: '/assets/Home/ClientsAndPartners/Clients/imagem11.jpg', alt: '' },
    { id: 10, src: '/assets/Home/ClientsAndPartners/Clients/imagem12.png', alt: '' },
    { id: 11, src: '/assets/Home/ClientsAndPartners/Clients/imagem13.png', alt: '' },
    { id: 12, src: '/assets/Home/ClientsAndPartners/Clients/imagem14.png', alt: '' },
    { id: 13, src: '/assets/Home/ClientsAndPartners/Clients/imagem15.jpg', alt: '' },
    { id: 14, src: '/assets/Home/ClientsAndPartners/Clients/imagem16.png', alt: '' },
    { id: 15, src: '/assets/Home/ClientsAndPartners/Clients/imagem17.png', alt: '' },
    { id: 16, src: '/assets/Home/ClientsAndPartners/Clients/imagem18.png', alt: '' },
    { id: 17, src: '/assets/Home/ClientsAndPartners/Clients/imagem19.png', alt: '' },
    { id: 18, src: '/assets/Home/ClientsAndPartners/Clients/imagem20.jpg', alt: '' },
    { id: 19, src: '/assets/Home/ClientsAndPartners/Clients/imagem21.png', alt: '' },
    { id: 20, src: '/assets/Home/ClientsAndPartners/Clients/imagem22.png', alt: '' },
    { id: 21, src: '/assets/Home/ClientsAndPartners/Clients/imagem23.png', alt: '' },
    { id: 22, src: '/assets/Home/ClientsAndPartners/Clients/imagem24.png', alt: '' },
    { id: 23, src: '/assets/Home/ClientsAndPartners/Clients/portobello.svg', alt: '' },
    { id: 24, src: '/assets/Home/ClientsAndPartners/Clients/imagem26.png', alt: '' },
    { id: 25, src: '/assets/Home/ClientsAndPartners/Clients/imagem27.png', alt: '' },
    { id: 26, src: '/assets/Home/ClientsAndPartners/Clients/imagem28.png', alt: '' },
    { id: 27, src: '/assets/Home/ClientsAndPartners/Clients/imagem29.jpg', alt: '' },
    { id: 28, src: '/assets/Home/ClientsAndPartners/Clients/imagem30.png', alt: '' },
    { id: 29, src: '/assets/Home/ClientsAndPartners/Clients/imagem31.jpg', alt: '' },
    { id: 30, src: '/assets/Home/ClientsAndPartners/Clients/ache-logo.png', alt: '' },
    { id: 31, src: '/assets/Home/ClientsAndPartners/Clients/bauducco-logo.png', alt: '' },
  ]

  const handleCtaNavigation = ({ ctaName, destination }) => {
    trackCtaClick({
      cta_name: ctaName,
      cta_location: 'home',
      destination_path: destination,
    })

    navigate(destination)
  }

  useEffect(() => {
    if (location.state?.scrollTo === 'solutions') {
      const element = document.getElementById('solutions')
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [location])

  return (
    <div className="Home">
      <div className="HomeTitleContainer">
        <h1 className="top">{t('home_page.title')}</h1>
        <h1 className="top">
          {t('home_page.title2')}{' '}
          <span className="highlight">{t('home_page.titleHighlight')}</span>
        </h1>
      </div>

      <div className="HomeVideo">
        <video
          autoPlay
          muted
          playsInline
          disablePictureInPicture
          onEnded={(e) => e.target.pause()}
        >
          <source src="/assets/Home/logoApllosHomeGif.mp4" type="video/mp4" />
        </video>
      </div>

      <div id="solutions" className="InnovativeSolutions">
        <h2>{t('home_page.solutionsHome.title')}</h2>
        <div className="solutions-container">
          <div className="Solutions">
            <h3>{t('home_page.solutionsHome.solutionsContainer.cardTitle')}</h3>
            <p>{t('home_page.solutionsHome.solutionsContainer.description')}</p>
            <button
              onClick={() =>
                handleCtaNavigation({
                  ctaName: 'home_solutions_data_saiba_mais',
                  destination: '/data',
                })
              }
            >
              {t('home_page.button')}
              <img
                src="/assets/Home/SVG - Seta para frente.png"
                alt="Seta apontando para a direita"
              />
            </button>
          </div>
          <div className="Solutions">
            <h3>{t('home_page.solutionsHome.solutionsContainer.cardTitle1')}</h3>
            <p>{t('home_page.solutionsHome.solutionsContainer.description1')}</p>
            <button
              onClick={() =>
                handleCtaNavigation({
                  ctaName: 'home_solutions_digital_saiba_mais',
                  destination: '/digital-transformation',
                })
              }
            >
              {t('home_page.button')}
              <img
                src="/assets/Home/SVG - Seta para frente.png"
                alt="Seta apontando para a direita"
              />
            </button>
          </div>
          <div className="Solutions">
            <h3>{t('home_page.solutionsHome.solutionsContainer.cardTitle2')}</h3>
            <p>{t('home_page.solutionsHome.solutionsContainer.description2')}</p>
            <button
              onClick={() =>
                handleCtaNavigation({
                  ctaName: 'home_solutions_supply_chain_saiba_mais',
                  destination: '/digital-supply-chain',
                })
              }
            >
              {t('home_page.button')}
              <img
                src="/assets/Home/SVG - Seta para frente.png"
                alt="Seta apontando para a direita"
              />
            </button>
          </div>
          <div className="Solutions">
            <h3>{t('home_page.solutionsHome.solutionsContainer.cardTitle3')}</h3>
            <p>{t('home_page.solutionsHome.solutionsContainer.description3')}</p>
            <button
              onClick={() =>
                handleCtaNavigation({
                  ctaName: 'home_solutions_cx_ax_saiba_mais',
                  destination: '/cx-ax',
                })
              }
            >
              {t('home_page.button')}
              <img
                src="/assets/Home/SVG - Seta para frente.png"
                alt="Seta apontando para a direita"
              />
            </button>
          </div>
        </div>
      </div>

      <div className="AIAgent">
        <div
          className="AIAgentBg"
          aria-hidden="true"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/assets/Home/paralax.png)`,
          }}
        />
        <div className="AIAgentOverlay" aria-hidden="true" />
        <div className="AIContent">
          <div className="AIMainSection">
            <div className="AIDescription">
              <h2>
                {t('home_page.aiAgent.title')} <br />
                {t('home_page.aiAgent.title1')}
                <strong>{t('home_page.aiAgent.strongTitle')}</strong>
              </h2>
              <p>
                {t('home_page.aiAgent.description')}
                <br />
                <br />
                {t('home_page.aiAgent.description1')}
              </p>
              <button
                onClick={() =>
                  handleCtaNavigation({
                    ctaName: 'home_agente_ia_saiba_mais',
                    destination: '/agente-de-ia',
                  })
                }
              >
                {t('home_page.button')}
              </button>
            </div>

            <div className="AICardsAndDiagram">
              <div className="AICards">
                <div className="AICard cxax">
                  <h3>
                    {t('home_page.aiAgent.aiAgentCards.title')}
                    <img src="/assets/Home/cxax.png" alt="ícone CX e AX" />
                  </h3>
                  <p>{t('home_page.aiAgent.aiAgentCards.description')}</p>
                </div>
                <div className="AICard business">
                  <h3>
                    {t('home_page.aiAgent.aiAgentCards.title1')}
                    <img src="/assets/Home/business.png" alt="ícone Negócio" />
                  </h3>
                  <p>{t('home_page.aiAgent.aiAgentCards.description1')}</p>
                </div>
                <div className="AICard digital">
                  <h3>
                    {t('home_page.aiAgent.aiAgentCards.title2')}
                    <img src="/assets/Home/digital.png" alt="ícone Digital" />
                  </h3>
                  <p>{t('home_page.aiAgent.aiAgentCards.description2')}</p>
                </div>
                <div className="AICard analytics">
                  <h3>
                    {t('home_page.aiAgent.aiAgentCards.title3')} <br />{' '}
                    {t('home_page.aiAgent.aiAgentCards.title4')}
                    <img src="/assets/Home/data.png" alt="ícone Dados e Analytics" />
                  </h3>
                  <p>{t('home_page.aiAgent.aiAgentCards.description3')}</p>
                </div>
              </div>
              <div className="Diagram">
                <img src={t('home_page.aiAgent.diagramImage')} alt="Fluxo IA" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="maturidade" className="maturity-level-container">
        <div className="maturity-content">
          <h2 className="maturity-title">
            {t('home_page.maturityLevel.title')}
            <span className="maturity-title-gradient">
              {t('home_page.maturityLevel.titleHighlight')}
            </span>
          </h2>
          <p className="maturity-subtitle">{t('home_page.maturityLevel.subtitle')}</p>
          <div className="maturity-ctas">
            <a
              href={process.env.REACT_APP_MATURITY_LEVEL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="maturity-btn maturity-btn--primary"
            >
              {t('home_page.maturityLevel.primaryCta')}
              <img
                src="/assets/Home/seta direita branca.png"
                alt={t('home_page.maturityLevel.primaryCtaAlt')}
              />
            </a>
          </div>
          <div className="maturity-stats">
            <div className="maturity-stat">
              <span className="maturity-stat-value">
                {t('home_page.maturityLevel.stats.time.value')}
              </span>
              <span className="maturity-stat-label">
                {t('home_page.maturityLevel.stats.time.label')}
              </span>
            </div>
            <div className="maturity-stat">
              <span className="maturity-stat-value">
                {t('home_page.maturityLevel.stats.questions.value')}
              </span>
              <span className="maturity-stat-label">
                {t('home_page.maturityLevel.stats.questions.label')}
              </span>
            </div>
            <div className="maturity-stat">
              <span className="maturity-stat-value">
                {t('home_page.maturityLevel.stats.free.value')}
              </span>
              <span className="maturity-stat-label">
                {t('home_page.maturityLevel.stats.free.label')}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="ApllosHome">
        <h1>
          <span>Απλος</span> (Apllos) - {t('home_page.apllosHome.title')}
        </h1>
        <p>
          {t('home_page.apllosHome.description')}
          <br />
          {t('home_page.apllosHome.description1')}
          <br />
          {t('home_page.apllosHome.description2')}
        </p>
        <button
          onClick={() =>
            handleCtaNavigation({
              ctaName: 'home_apllos_saiba_mais',
              destination: '/apllos',
            })
          }
        >
          {t('home_page.button')}
        </button>
      </div>

      <section className="Cases">
        <h1>{t('home_page.casesHome.title')}</h1>
        <div className="CasesContent">
          <div className="CasesImages">
            <img src="/assets/Home/multidevice.png" alt="Mockups dos cases" />
          </div>
          <div className="CasesText">
            <h2>
              {t('home_page.casesHome.title1')}
              <br />
              <span className="CasesSpan">{t('home_page.casesHome.titleSpan')}</span>
            </h2>
            <p>{t('home_page.casesHome.description')}</p>
            <button
              onClick={() =>
                handleCtaNavigation({
                  ctaName: 'home_cases_saiba_mais',
                  destination: '/cases',
                })
              }
            >
              {t('home_page.button')}
            </button>
          </div>
        </div>
      </section>

      <div className="OurClients">
        <h1>{t('home_page.ourClients')}</h1>
        <Pagination
          data={clients}
          autoplay={true}
          autoplayInterval={2500}
          itemsPerPage={10}
          mobileItemsPerPage={6}
          variant="home"
          controlsAlignment="center"
          infinite={true}
        >
          {(currentClients) => (
            <div className="ClientsGrid">
              {currentClients.map((client) => (
                <img
                  key={client.id}
                  src={client.src}
                  alt={client.alt}
                  className={`client-img client-${client.id}`}
                />
              ))}
            </div>
          )}
        </Pagination>
      </div>

      <div className="AwardsDiv">
        <div className="AwardsContent">
          <div className="AwardsSection">
            <h1>
              {t('home_page.awardsHome.description')}
              <br /> {t('home_page.awardsHome.description1')}
            </h1>
            <button
              onClick={() =>
                handleCtaNavigation({
                  ctaName: 'home_reconhecimento_saiba_mais',
                  destination: '/recognition',
                })
              }
            >
              {t('home_page.button')}
            </button>
          </div>
          <img className="gptw" src="/assets/Home/gptw.png" alt="Selo GPTW" />
        </div>
      </div>

      <div className="Partners">
        <h1>{t('home_page.partners')}</h1>
        <Pagination
          data={partners}
          itemsPerPage={5}
          autoplayInterval={2500}
          mobileItemsPerPage={5}
          variant="home"
          controlsAlignment="center"
          infinite={true}
        >
          {(currentPartners) => (
            <div className="PartnersGrid">
              {currentPartners.map((partner) => (
                <img key={partner.id} src={partner.src} alt={partner.alt} />
              ))}
            </div>
          )}
        </Pagination>
      </div>
    </div>
  )
}

export default Home
